<template>
	<b-field grouped>
		<template v-for="field in format">
			<b-numberinput v-if="field === 'day'" v-model="day" :controls="false" :placeholder="dayPlaceholder" @input="returnComputed()" expanded></b-numberinput>
			<b-select v-if="field === 'month'" v-model="month" :placeholder="monthPlaceholder" @input="returnComputed()" :expanded="expanded">
				<option v-for="(month, index) of months" :value="index" :key="index">
					{{ month }}
				</option>
			</b-select>
			<b-numberinput v-if="field === 'year'" v-model="year" :controls="false" :placeholder="yearPlaceholder" @input="returnComputed()" expanded></b-numberinput>
		</template>
	</b-field>
</template>
<script type="text/javascript">
export default {
	name: "rxeob-datepicker",
	props: {
        value: Date,
        language: {
            type: String,
            default: "English"
        },
		format: {
			type: Array,
			default: function () {
                return ["month", "day", "year"];
			}
        },
        expanded: {
            type: Boolean,
            default: false
        }
	},
    data: function() {
		return {
            day: null,
            month: null,
			year: null
        }
	},
	computed: {
		months: function () {
			if (this.language === "Spanish") {
				return ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
			} else {
				return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
			}
        },
        dayPlaceholder: function () {
            return (this.language === "Spanish") ? "D�a" : "Day";
        },
		monthPlaceholder: function () {
            return (this.language === "Spanish") ? "Mes" : "Month";
        },
        yearPlaceholder: function () {
            return (this.language === "Spanish") ? "A�o (AAAA)" : "Year (YYYY)";
		},
		computedValue: function () {
			var result;

            var inputDay = parseInt(this.day);
            var inputMonth = parseInt(this.month);
			var inputYear = parseInt(this.year);

			if (!(isNaN(inputDay) || isNaN(inputMonth) || isNaN(inputYear) ||
					inputDay < 1 || inputDay > this.getMaxDay() ||
					inputMonth < 0 || inputMonth > 11 ||
                inputYear < 1000 || inputYear > 9999)) {
                result = new Date(inputYear, inputMonth, inputDay);
                var offset = result.getTimezoneOffset() * -1;
                result.setMinutes(offset)
			}        
            return result;
        }
    },
    mounted: function () {
		if (this.value) {
            this.day = this.value.getDate();
            this.month = this.value.getMonth();
            this.year = this.value.getFullYear();
        }
    },
    methods: {
		getMaxDay: function () {
            switch (this.month) {
				case 1: // Feburary
					if (this.year) {
						return (this.year % 100 === 0) ? (this.year % 400 === 0 ? 29 : 28) : (this.year % 4 === 0 ? 29 : 28);
					} else {
						return 29;
                    }
                case 3: // April
                case 5: // June
                case 8: // September
                case 10: // November
                    return 30;
                default:
                    return 31;
            }
        },
        returnComputed: function () {
            this.$emit('input', this.computedValue);
        }
    }
}
</script>



// WEBPACK FOOTER //
// RxeobDatepicker.vue?7d5a8bfb